/* eslint-disable react/display-name */
import React from 'react'

function SantanderFooterSidebar() {
  return (
    <svg
      width="116"
      height="90"
      viewBox="0 0 116 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.1384 50.3839C82.9654 46.4203 81.853 42.4883 79.794 38.9341L61.6323 7.5809C60.2473 5.18936 59.2908 2.62777 58.7589 0L58.0008 1.31042C53.5046 9.07061 53.5046 18.6314 58 26.3916L72.5293 51.4743C77.0248 59.2352 77.0248 68.7967 72.5293 76.5569L71.7704 77.8674C71.2393 75.2396 70.282 72.678 68.897 70.2872L47.103 32.6628C45.7188 30.272 44.7615 27.7097 44.2303 25.0827L43.4714 26.3931C38.9914 34.1271 38.9775 43.6494 43.4267 51.3958L43.4259 51.3965L58.0008 76.5569C62.4954 84.3171 62.4954 93.8787 58.0008 101.64L57.2411 102.95C56.71 100.322 55.7534 97.7607 54.3684 95.3691L36.2068 64.016C33.7711 59.8108 32.6578 55.0769 32.8616 50.3877C13.4199 55.4501 0 66.2005 0 78.6476C0 95.9632 25.9683 110 58.0008 110C90.0325 110 116 95.9632 116 78.6476C116 66.1998 102.582 55.4471 83.1384 50.3839Z"
        fill="white"
      />
    </svg>
  )
}

export default React.memo(SantanderFooterSidebar)
